import { render, staticRenderFns } from "./GetCustomerSource.vue?vue&type=template&id=3a2fb856&scoped=true&"
import script from "./GetCustomerSource.vue?vue&type=script&lang=js&"
export * from "./GetCustomerSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2fb856",
  null
  
)

export default component.exports